var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDotsVertical = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10.5 10.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666M10.5 5a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M10.5 16.667a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
})));
export { SvgDotsVertical as ReactComponent };
export default __webpack_public_path__ + "assets/images/dots-vertical.d2cc6754063c5caa34244cb9a59e79a3.svg";